import React,{ Component } from 'react';
import {Row, Col, Button, ButtonGroup} from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from "../../../../components/SelectWrap";
import {handleFieldChange} from "../../../../Utils";
import countriesObj from "../../../../data/countries";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date: '',
            hour: '',
            affid: null,
            subid: null,
            country: null,
            minFactor: null,
            maxFactor: null
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(type) {
        this.props.onSubmit(this.state, type);
    }

    render() {
        return (
            <form onSubmit={this.handleFormSubmit}>
                <Row>
                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="date"
                            label="Date:"
                            onChange={this.handleFieldChange}
                            value={this.state.day}
                            required
                        />
                    </Col>
                    <Col lg={4}>
                        <FieldGroup
                            type="number"
                            name="hour"
                            label="Hour:"
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.hour}
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.affidValues}
                            label="Affid:"
                            name="affid"
                            onChange={this.handleFieldChange}
                            value={this.state.affid}
                            multi
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.subidValues}
                            label="Subid:"
                            name="subid"
                            onChange={this.handleFieldChange}
                            value={this.state.subid}
                            multi
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                        />
                    </Col>
                    <Col lg={4}>
                        <Row>
                        <Col lg={6}>
                            <FieldGroup
                                type="number"
                                name="minFactor"
                                label="Min. Factor:"
                                step={0.01}
                                onChange={this.handleFieldChange}
                                value={this.state.minFactor}
                            />
                        </Col>
                        <Col lg={6}>
                            <FieldGroup
                                type="number"
                                name="maxFactor"
                                label="max. Factor:"
                                step={0.01}
                                onChange={this.handleFieldChange}
                                value={this.state.maxFactor}
                            />
                        </Col>

                        </Row>
                    </Col>
                </Row>

                <ButtonGroup>
                    <Button type="button" bsStyle="info" className="m-b-15" onClick={() => this.handleFormSubmit('subid')}>Load Subids</Button>
                    <Button type="button" bsStyle="info" className="m-b-15" onClick={() => this.handleFormSubmit()}>Apply</Button>
                </ButtonGroup>
            </form>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/AdkQuickFactor/components/Form/index.js